export default __webpack_public_path__ + "static/media/logo.bec8fa3e.svg";